import { SM4 } from 'gm-crypto'

// ECB
function sm4encrypt(word, keyStr) {
  return SM4.encrypt(word, keyStr, {
    inputEncoding: 'utf8',
    outputEncoding: 'hex'
  })
}
function sm4decrypt(word, keyStr) {
  return SM4.decrypt(word, keyStr, {
    inputEncoding: 'base64',
    outputEncoding: 'utf8'
  })
}

export default {
  sm4encrypt,
  sm4decrypt
}
